import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-43512c36")
const _hoisted_1 = { class: "farming-record-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("地块信息")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("农事名称")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("干活时间")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "亩", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "人工", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "1人1天记1个人工", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 例如：1人干了两天，记2个人工；3人干了1.5天，记4.5个人工； ", -1)
const _hoisted_9 = { class: "cup-line" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*"),
  /*#__PURE__*/_createTextVNode("照片")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "最多9张", -1)
const _hoisted_12 = { class: "cup-line" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "视频", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "可上传1个视频", -1)
const _hoisted_15 = { class: "cup-line" }
const _hoisted_16 = { class: "pop-btn" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 提交 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_preview_video = _resolveComponent("preview-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, { border: true }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: _ctx.farmingTypeName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.farmingTypeName = $event)),
              onClick: _ctx.onClickType,
              readonly: "",
              label: "农事类型",
              placeholder: "点击选择类型"
            }, null, 8, ["modelValue", "onClick"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.selectedLandName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedLandName = $event)),
              onClick: _ctx.onClickLand,
              readonly: "",
              placeholder: "点击选择地块",
              rules: [{ required: true, message: '请选择地块' }]
            }, {
              label: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["modelValue", "onClick"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.farmingName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.farmingName = $event)),
              readonly: _ctx.isDisabled,
              placeholder: "请输入名称",
              rules: [{ required: true, message: '名称必填' }]
            }, {
              label: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue", "readonly"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.date = $event)),
              name: "date",
              readonly: "",
              class: "date-s",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDateDialog = true)),
              placeholder: "点击选择日期",
              rules: [{ required: true, message: '干活日期必选' }]
            }, {
              label: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _ctx.area,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.area = $event)),
              type: "number",
              label: "完成面积"
            }, {
              "right-icon": _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              border: false,
              modelValue: _ctx.person,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.person = $event)),
              type: "number",
              label: "人工投入"
            }, {
              "right-icon": _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_van_field, {
              name: "images",
              border: false,
              rules: [{ validator: _ctx.imageValidate, message: '请上传图片' }]
            }, {
              label: _withCtx(() => [
                _hoisted_10
              ]),
              input: _withCtx(() => [
                _createVNode(_component_stcp_h5_uploader, {
                  modelValue: _ctx.imageList,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.imageList = $event)),
                  multiple: "",
                  "after-read": _ctx.imageUploadAfter,
                  onDelete: _ctx.onDeleteImg,
                  "max-count": 9,
                  onPoster: _ctx.onClickImgPoster
                }, null, 8, ["modelValue", "after-read", "onDelete", "onPoster"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_van_field, {
              name: "videos",
              "max-count": 1,
              border: false
            }, {
              label: _withCtx(() => [
                _hoisted_13
              ]),
              input: _withCtx(() => [
                _createVNode(_component_stcp_h5_uploader, {
                  modelValue: _ctx.videoList,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.videoList = $event)),
                  "after-read": _ctx.afterUploadVideo,
                  accept: "video/*",
                  "max-count": 1,
                  onDelete: _ctx.onDeleteVideo,
                  onPoster: _ctx.onClickVideo
                }, null, 8, ["modelValue", "after-read", "onDelete", "onPoster"])
              ]),
              _: 1
            }),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_van_divider)
            ]),
            _createVNode(_component_van_field, {
              type: "textarea",
              row: 3,
              modelValue: _ctx.other,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.other = $event)),
              label: "其他事项",
              placeholder: "请输入"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showDateDialog,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDateDialog = $event)),
      round: "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: _ctx.currentDate,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentDate = $event)),
          type: "date",
          title: "干活时间",
          "max-date": _ctx.maxDate,
          "min-date": _ctx.minDate,
          onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDateDialog = false)),
          onConfirm: _ctx.dateConfirm
        }, null, 8, ["modelValue", "max-date", "min-date", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showTypePop,
      "onUpdate:show": _cache[14] || (_cache[14] = ($event: any) => (_ctx.showTypePop = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "农事类型",
          columns: _ctx.typeList,
          "default-index": _ctx.defaultIndex,
          onConfirm: _ctx.onConfirm,
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showTypePop = false))
        }, null, 8, ["columns", "default-index", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showLandPop,
      "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => (_ctx.showLandPop = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "地块",
          columns: _ctx.sourceLandList,
          "default-index": _ctx.landIndex,
          onConfirm: _ctx.onLandConfirm,
          onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showLandPop = false))
        }, null, 8, ["columns", "default-index", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_preview_video, {
      visible: _ctx.showVideos,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => (_ctx.showVideos = $event)),
      url: _ctx.videoUrl,
      autoplay: ""
    }, null, 8, ["visible", "url"])
  ]))
}